import React, { useRef } from 'react';
import classnames from 'classnames';
import PT from 'prop-types';
import { Col } from 'react-bootstrap';
import SessionSection from '../SessionSection';
import { sendCustomClick } from '../../../../utils/SnowplowUtils';
import { buttonTypes } from '../../../../constants/SnowplowConst';

const AttachmentItem = ({ attachment, showCompactLists, sendAnalytics, sessionId }) => {
    const { type, url, name, icon, fileName, id } = attachment;

    const colClass = classnames('padding-left-none margin-bottom-small session-attachments-item', {
        'col-lg-12': showCompactLists
    });
    const imageClass = classnames('session-attachments-img', {
        [`session-attachments-type-${type}`]: !icon,
        'show-compact-lists': showCompactLists
    });

    const attachmentLinkRef = useRef(null);

    const onAttachmentClick = () => {
        sendAnalytics(attachment);
    };

    const onAttachmentLinkClick = () => {
        sendCustomClick(
            buttonTypes.sessionAssetDownloaded,
            buttonTypes.sessionAssetDownloaded,
            attachmentLinkRef,
            { asset_id: id, asset_type: type, asset_link: url, asset_name: name, session_id: sessionId },
            buttonTypes.sessionAssetDownloaded
        );
    };

    return (
        <Col className={colClass} xs={12} sm={6} md={4}>
            <a href={url} download={fileName || true} target="_blank" ref={attachmentLinkRef} onClick={onAttachmentLinkClick}>
                <img title="Click to Download" crossOrigin=''
                    onClick={onAttachmentClick}
                    src={icon}
                    className={imageClass}
                />
                <div className="font-size-14 session-attachments-name padding-top-xs text-ellipsis">
                    {name}
                </div>
            </a>
        </Col>
    );
};
const AttachmentShape = PT.shape({
    type: PT.string,
    url: PT.string,
    name: PT.string,
    icon: PT.string,
    fileName: PT.string
});
AttachmentItem.propTypes = {
    attachment: AttachmentShape.isRequired,
    showCompactLists: PT.bool,
    sendAnalytics: PT.func.isRequired
};

const SessionAttachments = ({sessionId, attachments = [], attachmentsTitle, sendAnalytics, showCompactLists, stickSectionsToLeft}) => {
    if (!attachments?.length) {
        return null;
    }

    return (
        <SessionSection
            title={attachmentsTitle || 'Attachments'}
            classTitle="text-ellipsis"
            className="session-attachments"
            stickSectionsToLeft={stickSectionsToLeft}
            classChildren="session-page-list"
        >
            {attachments.map((attachment, idx) => (
                <AttachmentItem
                    key={idx}
                    sessionId={sessionId}
                    attachment={attachment}
                    showCompactLists={showCompactLists}
                    sendAnalytics={sendAnalytics}
                />
            ))}
        </SessionSection>
    );
};
SessionAttachments.propTypes = {
    attachments: PT.arrayOf(AttachmentShape),
    attachmentsTitle: PT.string,
    sendAnalytics: PT.func.isRequired,
    showCompactLists: PT.bool,
    stickSectionsToLeft: PT.bool,
};

export default SessionAttachments;
